// yo — checkin/quickCheck/stepTracker blocks translated.
export const yo = {
  "common": {
    "loading": "Ó ń gbé wọlé…",
    "save": "Fipamọ́",
    "cancel": "Fagilé",
    "delete": "Pa rẹ́",
    "edit": "Ṣàtúnṣe",
    "close": "Tì",
    "confirm": "Fìdíhàn",
    "back": "Padà",
    "next": "Tókàn",
    "submit": "Fi ránṣẹ́",
    "search": "Wá",
    "select": "Yan",
    "or": "Tàbí",
    "and": "àti",
    "note": "Note",
    "viewAll": "Wo gbogbo rẹ̀",
    "learnMore": "Kọ́ síi",
    "getStarted": "Bẹ̀rẹ̀",
    "continue": "Tẹ̀síwájú",
    "saving": "Ó ń fipamọ́…"
  },
  "nav": {
    "dashboard": "Pátákó ìṣàmúlò",
    "nutrition": "Oúnjẹ Ọlọ́gbọ́n",
    "family": "Ẹbí",
    "checkIn": "Ìṣàyẹ̀wò ojoojúmọ́",
    "insights": "Ìmọ̀ inú",
    "trends": "Ìṣípayá",
    "habits": "Ìṣesí",
    "medications": "Òògùn",
    "expertSupport": "Ìrànlọ́wọ́ alámọ̀",
    "profile": "Àpèjúwe",
    "healthHub": "Ibùdó Ìlera",
    "support": "Ìrànlọ́wọ́",
    "wellness": "Àlàáfíà",
    "education": "Ẹ̀kọ́",
    "community": "Àdúgbò",
    "preventiveHealth": "Ìlera ìdènà àìsàn",
    "womensHealth": "Ìlera Obìnrin",
    "reminders": "Ìránti ìlera",
    "meals": "Oúnjẹ",
    "orders": "Àṣẹ",
    "subscription": "Ìforúkọsílẹ̀",
    "logout": "Jáde"
  },

  "navShort": {
    "dashboard": "Ile",
    "nutrition": "Ounjẹ",
    "family": "Ìdílé",
    "care": "Iṣẹ́",
    "support": "Ìrànlọ́wọ́",
    "profile": "Profaili"
  },
  "auth": {
    "login": "Wọlé",
    "register": "Ṣẹ̀dá àkọsílẹ̀",
    "logout": "Jáde",
    "email": "Ìméèlì",
    "password": "Ọ̀rọ̀-ìṣírò",
    "name": "Orúkọ kíkún",
    "forgotPassword": "Sé o gbàgbé ọ̀rọ̀-ìṣírò?",
    "noAccount": "O kò ní àkọsílẹ̀?",
    "haveAccount": "Already have an account?",
    "signInHere": "Sign in here",
    "signUpHere": "Sign up here",
    "welcomeBack": "Káàbọ̀ pàdà!",
    "getStarted": "Let's get started",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "vendorLogin": "Vendor Login",
    "createOne": "Dá ọ̀kan",
    "tagline": "Ṣe ìṣàmúlò ìlera rẹ — ìṣàyẹ̀wò rọrùn lóòjọ́ kọ̀ọ̀kan.",
    "takes30s": "Ó dín ní ìṣẹ́jú-àáyá 30",
    "emailPlaceholder": "iwo@apẹẹrẹ.com",
    "passwordPlaceholder": "Ọ̀rọ̀-ìṣírò rẹ",
    "checking": "Ó ń ṣàyẹ̀wò…",
    "continue": "Tẹ̀síwájú",
    "secureMessage": "Ààbò àti àṣírí — alaye rẹ wà ní àpamọ́",
    "biometricSoon": "Ìwọlé bíokémetríkì — Yóò dé láìpẹ́",
    "showPassword": "Fi ọ̀rọ̀-ìṣínà hàn",
    "hidePassword": "Fi ọ̀rọ̀-ìṣínà pamọ́",
    "vendor": {
      "title": "Ìwọlé fún Àwọn Alájọṣepọ̀ (Vendor)",
      "subtitle": "Wọlé sí ojú-iṣẹ́ HealthLoop fún àwọn alájọṣepọ̀",
      "businessEmail": "Ímèlì iṣẹ́",
      "emailPlaceholder": "alajosepo@ise.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Ó ń wọlé lọ...",
      "signIn": "Wọlé",
      "notVendorYet": "Ṣé o kò tíì jẹ́ alájọṣepọ̀?",
      "registerBusiness": "Forúkọ iṣẹ́ rẹ sílẹ̀",
      "areYouUser": "Ṣé oníbàárà ni ẹ́?",
      "userLogin": "Ìwọlé Oníbàárà",
      "welcomeBackToast": "Ẹ kú àbọ̀ padà!",
      "genericError": "Ìwọlé kùnà. Jọ̀wọ́ tún dánwò."
    },
    "admin": {
      "backToUserLogin": "Ìwọlé oníbàárà",
      "title": "Ìwọlé fún Alákòóso (Admin)",
      "restrictedBadge": "Ìhámọ́",
      "tagline": "Ojú-iṣẹ́ HealthLoop — a nílò àṣẹ alákòóso.",
      "emailLabel": "Ímèlì alákòóso",
      "emailPlaceholder": "admin@domain.com",
      "passwordLabel": "Ọ̀rọ̀-ìṣínà",
      "passwordPlaceholder": "Tẹ ọ̀rọ̀-ìṣínà alákòóso rẹ",
      "signingIn": "Ó ń wọlé lọ…",
      "submit": "Wọlé sí ojú-iṣẹ́ alákòóso",
      "secureNote": "Ìsopọ̀ tó láàbò · Ìjíròrò rẹ jẹ́ àṣírí",
      "restrictedTitle": "Apá yìí wà fún àwọn alákòóso nìkan.",
      "restrictedBody": "O ti wọlé, ṣùgbọ́n o kò ní àṣẹ alákòóso. Jáde kúrò láti wọlé pẹ̀lú àkópọ̀ mìíràn, tàbí kí o padà sí ojú-iṣẹ́ àkọ́kọ́.",
      "signOut": "Jáde",
      "backToApp": "Padà sí inú ètò"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Báwo ni ara rẹ ṣe rí lónìí?",
      "subtitle": "Ayẹwo kíákíá — èyí kò ju ìṣẹ́jú kan lọ"
    },
    "section1": {
      "title": "Kí ni o ṣàkíyèsí lónìí?",
      "hint": "(Yan gbogbo èyí tí ó bá a mu)"
    },
    "environment": {
      "title": "Àyíká rẹ lónìí",
      "hint": "Ràn wá lọ́wọ́ láti mọ bí àyíká rẹ ṣe rí"
    },
    "basicChecks": {
      "title": "Ayẹwo kò-ṣe-má-ní kíákíá",
      "hint": "O lè fò ó ṣùgbọ́n yóò ràn wá lọ́wọ́"
    },
    "validation": {
      "pickOne": "Jọ̀wọ́ dáhùn ó kéré tán ìbéèrè kan"
    },
    "submit": {
      "cta": "Gba Ìfihàn lórí Ìlera Mi",
      "saving": "À ń gbà á sílẹ̀...",
      "analyzing": "À ń ṣàyẹ̀wò ìlànà ìlera rẹ...",
      "savedToast": "✅ A ti gba ayẹwo sílẹ̀! À ń ṣàyẹ̀wò ìlànà ìlera rẹ..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Olùtọpa Ìṣísẹ̀",
      "subtitle": "Olùtọpa ìgbésẹ̀ rẹ pẹ̀lú òtítọ́ inú",
      "backToDashboard": "Padà sí ojú-ewé"
    },
    "today": {
      "title": "Ìṣísẹ̀ òní",
      "goalProgress": "Ìṣísẹ̀ {{current}} / {{goal}}",
      "goalReached": "O ti dé ibi tí o fẹ́ — iṣẹ́ gidi!",
      "keepGoing": "Tẹ̀síwájú — o wà lórí ọ̀nà tó tọ́."
    },
    "streak": {
      "label": "Itẹ̀síwájú lọ́wọ́lọ́wọ́",
      "days": "ọjọ́ {{count}}",
      "daysPlural": "ọjọ́ {{count}}"
    },
    "badges": {
      "title": "Àwọn Àmì Ẹ̀yẹ",
      "empty": "O ó gba àwọn àmì ẹ̀yẹ bí o bá ṣe ń tẹ̀síwájú nínú ìlànà rẹ."
    },
    "reminders": {
      "title": "Ìránnilétí láti rìn",
      "hint": "Ìránnilétí pẹ̀lẹ́ láti rìn díẹ̀ lẹ́yìn tí o bá ti jókòó fún ìgbà pípẹ́.",
      "enabled": "O ti wà ní ṣíṣí",
      "disabled": "O ti wà ní títì"
    },
    "insights": {
      "weeklyAverage": "Ìpíndọ́gba fún ọ̀sẹ̀",
      "weeklyGoal": "Àfojúsùn fún ọ̀sẹ̀"
    },
    "actions": {
      "connect": "So ohun èlò ìṣísẹ̀ pọ̀",
      "manualLog": "Kọ ìṣísẹ̀ rẹ fúnra rẹ",
      "changeGoal": "Yí àfojúsùn ojoojúmọ́ padà"
    }
  },
  "checkin": {
    "header": {
      "title": "Ayẹwo Ilera Ojoojúmọ́",
      "subtitle": "Kò ju ìṣẹ́jú kan lọ",
      "restDayLink": "Ara mi kò lọ́fẹ̀ẹ́ rẹ̀ lónìí"
    },
    "snapshot": {
      "title": "Ojú-ewé rẹ, a ti sọ di tuntun",
      "healthScore": "Ipele ìlera",
      "todayTasks": "Àwọn iṣẹ́ òní",
      "dayStreak": "ọjọ́ itẹ̀síwájú"
    },
    "resume": {
      "banner": "Bẹ̀rẹ̀ láti ibi tí o dúró sí",
      "startFresh": "Bẹ̀rẹ̀ tuntun",
      "dismiss": "Pa á tì"
    },
    "progress": {
      "allSet": "Gbogbo rẹ̀ ti yanjú",
      "step": "Ìgbésẹ̀ {{current}} nínú {{total}}",
      "ariaLabel": "Ìtẹ̀síwájú ayẹwo ojoojúmọ́: {{done}} nínú {{total}} apá ti parí"
    },
    "insights": {
      "title": "Ìfihàn lórí Ìlera Rẹ",
      "subtitle": "Èyí tí a gbé kalẹ̀ fún ọ lónìí",
      "insightForYou": "Ìfihàn fún ọ",
      "simpleActions": "Àwọn ìgbésẹ̀ rọrùn tí o lè gbé",
      "whenToSeekHelp": "Ìgbà tí o lè wá ìrànlọ́wọ́",
      "nhsAdvice": "Tí ọkàn rẹ kò bá balẹ̀, kàn sí NHS 111 tàbí dókítà rẹ (GP)",
      "backToDashboard": "Padà sí Ojú-ewé",
      "newCheckIn": "Ayẹwo Tuntun",
      "disclaimer": "HealthLoop ń pèsè ìtọ́sọ́nà fún ìlera rẹ, kì í ṣe ìwòsàn tàbí ìdánimọ̀ àìsàn."
    },
    "restDay": {
      "title": "Ìsinmi jẹ́ apá kan ìgbésí ayé.",
      "body": "A ó wà níbí lọ́la, nígbà tí o bá ṣe tán.",
      "streakNote": "Itẹ̀síwájú rẹ kò yipada — òun náà kàn ń sinmi ni.",
      "backToDashboard": "Padà sí ojú-ewé",
      "changedMind": "Ní tòótọ́, mo fẹ́ ṣe ayẹwo mi lónìí."
    },
    "feelings": {
      "title": "Báwo ni ara rẹ ṣe rí lónìí?",
      "hint": "Yan gbogbo èyí tí ó bá ọ lára mu",
      "tired": "Ara mi rẹwẹ̀sì",
      "headache": "Erifọ́",
      "stressed": "Ìdààmú ọkàn tàbí iṣẹ́ púpọ̀",
      "pain": "Ara dídùn tàbí ìrora",
      "okay": "Ara mi dán gájá lónìí"
    },
    "basics": {
      "title": "Àwọn nǹkan kò-ṣe-má-ní",
      "sleepQ": "Ǹjẹ́ o sùn dáadáa lálẹ́ àná?",
      "waterQ": "Ǹjẹ́ o ti mu omi tó pọ̀ tó lónìí?",
      "foodQ": "Ǹjẹ́ o jẹun dáadáa lónìí?",
      "activityQ": "Báwo ni o ṣe ṣiṣẹ́ tó lónìí?",
      "yes": "Bẹ́ẹ̀ ni",
      "notReally": "Rárá",
      "notYet": "Ó kù díẹ̀",
      "notActive": "N kò ṣiṣẹ́ rárá",
      "lightActivity": "Iṣẹ́ fẹ́lẹ́fẹ́lẹ́",
      "active": "Mo ṣiṣẹ́ dáadáa"
    },
    "mind": {
      "title": "Ọkàn àti okun ara",
      "stressQ": "Báwo ni ìpele ìdààmú ọkàn rẹ ṣe rí lónìí?",
      "moodQ": "Báwo ni inú rẹ ṣe rí lónìí?",
      "energyQ": "Báwo ni okun ara rẹ ṣe rí lónìí?",
      "low": "Ó kéré",
      "moderate": "Ó bójú mu",
      "high": "Ó ga",
      "neutral": "Kò ga kò rẹlẹ̀",
      "good": "Ó dára",
      "okay": "Ó wà ní ìwọ̀nba"
    },
    "day": {
      "title": "Ọjọ́ rẹ",
      "routineQ": "Ǹjẹ́ o tẹ̀lé ìlànà iṣẹ́ rẹ lónìí?",
      "yes": "Bẹ́ẹ̀ ni",
      "no": "Rárá"
    },
    "environment": {
      "title": "Àyíká rẹ lónìí",
      "describeQ": "Báwo ni o ṣe lè ṣàpèjúwe àyíká rẹ?",
      "comfortable": "😊 Ó tura",
      "slightlyUncomfortable": "😐 Kò fi bẹ́ẹ̀ tura",
      "challenging": "😓 Ó nira",
      "affectedQ": "Ǹjẹ́ àyíká rẹ nípa lórí bí ara rẹ ṣe rí?",
      "yes": "Bẹ́ẹ̀ ni",
      "no": "Rárá",
      "exposureLabel": "Ìfarahàn sí (yan gbogbo èyí tí ó bá a mu)",
      "heat": "🌡️ Ooru",
      "cold": "❄️ Òtútù",
      "noise": "🔊 Ariwo",
      "dustSmoke": "💨 Eruru tàbí èéfín",
      "crowded": "👥 Àpérò púpọ̀",
      "none": "✅ Kò sí kankan"
    },
    "submit": {
      "analyzing": "À ń ṣàyẹ̀wò ìlànà ìlera rẹ...",
      "cta": "Wo Ìfihàn lórí Ìlera Mi"
    },
    "toast": {
      "savedFull": "A ti gba ayẹwo rẹ sílẹ̀! Ojú-ewé rẹ ti yípadà.",
      "savedShort": "A ti gba ayẹwo sílẹ̀."
    }
  },
  "onboarding": {
    "welcome": "Káàbọ̀",
    "completeSetup": "Parí ètò",
    "stepProgress": "Ìgbésẹ̀ {{step}} nínú {{total}}",
    "percentComplete": "{{percent}}% ti parí",
    "welcomeToast": "Káàbọ̀ sí HealthLoop! Àkọsílẹ̀ rẹ ti múra.",
    "errorAgeRange": "Jọ̀wọ́ yan àkójọ ọjọ́-orí rẹ",
    "errorCountry": "Jọ̀wọ́ yan orílẹ̀-èdè rẹ",
    "errorGoal": "Jọ̀wọ́ yan èròngbà àkọ́kọ́ rẹ",
    "errorCuisine": "Yan o kéré tán ààyò oúnjẹ kan",
    "errorGeneric": "Ìṣètò kò pé. Jọ̀wọ́ gbìyànjú lẹ́ẹ̀kansí.",
    "step1Title": "Káàbọ̀ sí HealthLoop! 👋",
    "step1Subtitle": "Jẹ́ ki á ṣe ètò ìrìnàjò ìlera rẹ",
    "ageRangeLabel": "Kí ni àkójọ ọjọ́-orí rẹ?",
    "genderLabel": "Akọ tàbí abo (kì í ṣe dandan)",
    "gender_male": "Akọ",
    "gender_female": "Abo",
    "gender_non-binary": "Mìíràn",
    "gender_prefer_not_to_say": "Mi ò fẹ́ sọ",
    "step2Title": "Níbo ni o ń gbé? 🌍",
    "step2Subtitle": "Èyí yóò ràn wá lọ́wọ́ láti dábàá oúnjẹ àṣà rẹ",
    "countryLabel": "Yan orílẹ̀-èdè rẹ",
    "country_uk": "Ilẹ̀ọba Aláwọ̀-funfun",
    "country_nigeria": "Nàìjíríà",
    "country_ghana": "Gàná",
    "country_kenya": "Kẹ́nyà",
    "country_south_africa": "Gúúsù Áfríkà",
    "country_usa": "Orílẹ̀-Èdè Amẹ́ríkà",
    "country_canada": "Kánádà",
    "country_india": "Índíà",
    "country_jamaica": "Jàméìkà",
    "country_other": "Òmíràn",
    "step3Title": "Kí ni èròngbà àkọ́kọ́ rẹ? 🎯",
    "step3Subtitle": "Yan ohun pàtàkì jùlọ fún ìlera rẹ",
    "additionalGoals": "Èròngbà mìíràn? (kì í ṣe dandan)",
    "goal_weight_loss": "Ìdinkù ìwọ̀n",
    "goalDesc_weight_loss": "Pàdánù ìwọ̀n ní ọ̀nà tó ní àlàáfíà",
    "goal_weight_maintenance": "Tọ́jú ìwọ̀n",
    "goalDesc_weight_maintenance": "Wà ní ìwọ̀n òní rẹ",
    "goal_muscle_gain": "Kọ́ iṣan",
    "goalDesc_muscle_gain": "Gba okun àti iṣan",
    "goal_general_wellness": "Ìlera gbogbogbòò",
    "goalDesc_general_wellness": "Ìdàgbàsókè ìlera lápapọ̀",
    "goal_better_sleep": "Oorun tó dára",
    "goalDesc_better_sleep": "Dára sí ojú oorun",
    "goal_reduce_stress": "Dín ìnira kù",
    "goalDesc_reduce_stress": "Tọ́jú ìnira dáradára",
    "goal_increase_energy": "Agbára pọ̀ síi",
    "goalDesc_increase_energy": "Nírìírí agbára púpọ̀ síi",
    "step4Title": "Ààyò oúnjẹ 🍽️",
    "step4Subtitle": "Yan oúnjẹ tó wù ọ́ àti àwọn àìmọ́ tó kàn",
    "cuisineLabel": "Oúnjẹ tó wù ọ́",
    "cuisineHint": "Yan o kéré tán ọ̀kan (o lè yan jù kan lọ)",
    "dietaryLabel": "Àìmọ́ oúnjẹ (kì í ṣe dandan)",
    "diet_vegetarian": "Aláìjẹ ẹran",
    "diet_vegan": "Olójẹ-ewé pípé",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Aláìní glutẹ́nì",
    "diet_dairy_free": "Aláìní wàrà",
    "diet_pescatarian": "Eja nìkan",
    "step5Title": "Àwọn ipò ìlera 🏥",
    "step5Subtitle": "Kì í ṣe dandan — ó máa ràn wá lọ́wọ́ láti dábàá dáradára",
    "conditionsLabel": "Sé o ní èyíkéyìí nínú àwọn àìsàn yìí?",
    "conditionsHint": "Ìmọ̀ yìí wà ní àpamọ́, fún ìfọ̀rọ̀wérọ̀ rẹ nìkan",
    "condition_diabetes": "Àtọ̀gbẹ",
    "condition_hypertension": "Ipá ẹ̀jẹ̀ gíga",
    "condition_heart_disease": "Àìsàn ọkàn",
    "condition_thyroid": "Ìṣòro tairoidu",
    "condition_celiac": "Celiac",
    "condition_ibs": "Ìṣòro ìfun",
    "condition_none": "Kò sí",
    "privacyTitle": "Àlàyé rẹ wà ní àpamọ́",
    "privacyBody": "Àwọn ìmọ̀ rẹ ti wà ní àlàfíà a sì n tọ́jú wọn dáradára. À ń lò wọn nìkan láti ṣe ètò rẹ pẹ̀lú àbá oúnjẹ, ìmọ̀ràn ìlera, àti ìfitóni. À kì yóò pín wọn pẹ̀lú ẹnikẹ́ni láìsí ìfọwọ́sí rẹ.",
    "trackMedication": "Mo fẹ́ tọpinpin òògùn mi",
    "specialistInterest": "Ìjíròrò pẹ̀lú alámọ̀ wúni lójú",
    "welcomeTitle": "Káàbọ̀ sí HealthLoop! 👋",
    "welcomeSubtitle": "Ẹ jẹ́ kí a tún ìrírí ìlera rẹ àti ìmọ̀ ìgbé-ayé rẹ ṣe nípasẹ̀ AI ní àwọn ìgbésẹ̀ díẹ̀",
    "stepLabel": "Ìgbésẹ̀ {{current}} nínú {{total}}",
    "skipForNow": "Fo fún ìsinsìnyí",
    "skipToast": "O le parí ètò ìforúkọsílẹ̀ rẹ nígbàkúgbà láti ojú-ewé rẹ",
    "back": "Padà",
    "next": "Tẹ̀síwájú",
    "completing": "À n parí rẹ̀...",
    "complete": "Parí Ètò",
    "successToast": "Káàbọ̀ sí HealthLoop! A ti tún ìrírí rẹ ṣe báyìí 🎉",
    "failureToast": "Kò ṣeé ṣe láti parí ètò rẹ",
    "validation": {
      "basicInfo": "Jọ̀wọ́ kọ gbogbo àlàyé rẹ kíkún",
      "pickGoal": "Jọ̀wọ́ yan ó kéré tán àfojúsùn ìlera kan",
      "pickPrimary": "Jọ̀wọ́ yan àfojúsùn rẹ tó ṣe pàtàkì jùlọ",
      "pickRegion": "Jọ̀wọ́ yan agbègbè àṣà rẹ fún àbá oúnjẹ tó rọrùn fún ọ",
      "pickFocus": "Jọ̀wọ́ yan ohun tí o fẹ́ kójú mọ́ jùlọ fún ìlera rẹ"
    },
    "step1": {
      "title": "Ìrísí Ìlera Rẹ",
      "description": "Ràn wá lọ́wọ́ láti kọ ìmọ̀ ìlera AI tó bá ìgbé-ayé rẹ mu",
      "age": "Ọjọ́ orí *",
      "agePlaceholder": "bí àpẹẹrẹ, 30",
      "height": "Gíga (cm) *",
      "heightPlaceholder": "bí àpẹẹrẹ, 170",
      "weight": "Ìwọ̀n (kg) *",
      "weightPlaceholder": "bí àpẹẹrẹ, 70"
    },
    "step2": {
      "title": "Àwọn Àfojúsùn Ìlera Rẹ",
      "description": "Yan gbogbo èyí tí o fẹ́, lẹ́yìn náà yan èyí tó ṣe pàtàkì jùlọ",
      "primaryLabel": "Yan Àfojúsùn Rẹ Tó Ṣe Pàtàkì Jùlọ *",
      "primaryBadge": "Pàtàkì"
    },
    "step3": {
      "title": "🌍 Àṣà & Oúnjẹ Tí O Fẹ́ràn",
      "description": "Ràn wá lọ́wọ́ láti tún àbá oúnjẹ rẹ ṣe",
      "regionLabel": "Agbègbè Àṣà *",
      "regionHint": "Yan àṣà rẹ fún àbá oúnjẹ tó bá rẹ mu",
      "countryLabel": "Orílẹ̀-èdè (Kò pọn dandan)",
      "countryPlaceholder": "bí àpẹẹrẹ, Nigeria, Kenya, Jamaica",
      "countryHint": "Fún àwọn àbá oúnjẹ tó túbọ̀ ṣe pàtó fún ọ",
      "foodPrefLabel": "Onírúurú Oúnjẹ Tí O Fẹ́"
    },
    "step4": {
      "title": "Ìfọkànsí Ìlera Jùlọ",
      "description": "Yan apá ibi tí o fẹ́ kójú mọ́ jùlọ"
    },
    "step5": {
      "title": "Ohun Tí O Fẹ́ràn",
      "description": "Tún ìrírí HealthLoop rẹ ṣe bí o ṣe fẹ́",
      "trackMeds": "Tẹ̀lé Lílò Oògùn",
      "trackMedsHint": "Gba ààyè láti tẹ̀lé lílò oògùn rẹ àti ìrántí oògùn ojoojúmọ́",
      "specialist": "Mo nífẹ̀ẹ́ sí Ìrànlọ́wọ́ Òṣìṣẹ́ Ìlera",
      "specialistHint": "Gba ààyè láti rí àwọn òṣìṣẹ́ ìlera, àwọn amòye oúnjẹ, àti àwọn amòye ìlera ọpọlọ",
      "confidentialTitle": "Ìrànlọ́wọ́ Àṣírí:",
      "confidentialBody": "Gbogbo àlàyé rẹ wà ní àbò, a sì n lò ó fún ìlera rẹ nìkan."
    },
    "step6": {
      "title": "Ìṣàtúnṣe Oúnjẹ",
      "description": "Ràn wá lọ́wọ́ láti fún ọ ní àbá oúnjẹ tó bá adùn ẹnu rẹ àti ìlera rẹ mu",
      "cuisinesLabel": "Oúnjẹ Tí O Fẹ́ràn (Kò pọn dandan)",
      "cuisinesHint": "Yan àwọn irú oúnjẹ tí o nífẹ̀ẹ́ sí jùlọ",
      "dietaryLabel": "Ìhámọ́ Oúnjẹ (Kò pọn dandan)",
      "dietaryHint": "Yan èyíkéyìí tó kan ọ̀ rẹ",
      "allergiesLabel": "Ẹ̀hun Oúnjẹ (Kò pọn dandan)",
      "allergiesHint": "Yan oúnjẹ èyíkéyìí tí kì í bá ọ lára mu",
      "personalisedTitle": "Oúnjẹ Tí A Túnṣe:",
      "personalisedBody": "A ó lo àwọn ìfẹ́ràn wọ̀nyí láti fún ọ ní àbá oúnjẹ tó bá adùn ẹnu rẹ mu. O le yí èyí padà nígbàkúgbà nínú Ètò."
    },
    "healthGoals": {
      "better_sleep": "Oòrùn Dídùn",
      "reduce_stress": "Dín Àníyàn Kù",
      "increase_energy": "Agbára Púpọ̀",
      "weight_management": "Ìṣàkóso Ìwọ̀n",
      "improve_fitness": "Ìlera Ara",
      "better_nutrition": "Oúnjẹ Tó Dára",
      "mental_wellness": "Ìlera Ọpọlọ",
      "chronic_condition": "Ìtọ́jú Ara"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Ìlera Ọpọlọ",
        "description": "Kó jú mọ́ inú dídùn, àníyàn, àti ìlera ọkàn"
      },
      "physical_fitness": {
        "label": "Ìlera Ara",
        "description": "Kó jú mọ́ eré-ìdárayá, agbára, àti sísun ara"
      },
      "nutrition": {
        "label": "Oúnjẹ",
        "description": "Kó jú mọ́ oúnjẹ jíjẹ àti jíjẹun lọ́nà tó tọ́"
      },
      "sleep": {
        "label": "Didára Oòrùn",
        "description": "Kó jú mọ́ ìsinmi, ìlànà oòrùn, àti ìmúradà"
      },
      "stress_management": {
        "label": "Ìṣàkóso Àníyàn",
        "description": "Kó jú mọ́ ìtura ara àti dídín àníyàn kù"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Ìwọ̀-Oòrùn Áfíríkà",
        "description": "Oúnjẹ Nigerian, Ghanaian, Senegalese"
      },
      "east_african": {
        "label": "Ìlà-Oòrùn Áfíríkà",
        "description": "Oúnjẹ Kenyan, Ethiopian, Tanzanian"
      },
      "north_african": {
        "label": "Àríwá Áfíríkà",
        "description": "Oúnjẹ Moroccan, Egyptian"
      },
      "southern_african": {
        "label": "Gúúsù Áfíríkà",
        "description": "Oúnjẹ South African"
      },
      "caribbean": {
        "label": "Caribbean",
        "description": "Oúnjẹ Jamaican, Trinidadian, Barbadian"
      },
      "middle_eastern": {
        "label": "Middle Eastern",
        "description": "Oúnjẹ Lebanese, Palestinian, Syrian"
      },
      "south_asian": {
        "label": "South Asian",
        "description": "Oúnjẹ Indian, Pakistani, Bangladeshi"
      },
      "east_asian": {
        "label": "East Asian",
        "description": "Oúnjẹ Chinese, Japanese, Korean"
      },
      "southeast_asian": {
        "label": "Southeast Asian",
        "description": "Oúnjẹ Thai, Vietnamese, Indonesian"
      },
      "western": {
        "label": "Ìwọ̀-Oòrùn",
        "description": "Oúnjẹ American, European"
      },
      "latin_american": {
        "label": "Latin American",
        "description": "Oúnjẹ Mexican, Brazilian, Argentine"
      },
      "mediterranean": {
        "label": "Mediterranean",
        "description": "Oúnjẹ Greek, Italian, Spanish"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Ìbílẹ̀",
        "description": "Oúnjẹ láti agbègbè rẹ ní pàtàkì"
      },
      "mixed": {
        "label": "Àdàlú",
        "description": "Àdàlú oúnjẹ agbègbè rẹ àti tòkè-òkun"
      },
      "international": {
        "label": "Kárí-ayé",
        "description": "Onírúurú oúnjẹ láti gbogbo àgbáyé"
      }
    },
    "cuisines": {
      "west_african": "Ìwọ̀-Oòrùn Áfíríkà",
      "caribbean": "Caribbean",
      "mediterranean": "Mediterranean",
      "asian": "Asian",
      "western": "Western",
      "indian": "Indian",
      "middle_eastern": "Middle Eastern",
      "general": "Gbogbo Oúnjẹ"
    },
    "dietary": {
      "vegetarian": "Vegetarian",
      "vegan": "Vegan",
      "pescatarian": "Pescatarian",
      "gluten_free": "Gluten-Free",
      "dairy_free": "Dairy-Free",
      "low_carb": "Low-Carb"
    },
    "allergies": {
      "nuts": "Ẹ̀pà",
      "shellfish": "Eja Oníkarawun",
      "dairy": "Wàrà",
      "eggs": "Ẹyin",
      "soy": "Soy",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Nàìjíríà",
    "cuisine_ghanaian": "Gánà",
    "cuisine_senegalese": "Sẹ̀nẹ̀gàlì",
    "cuisine_kenyan": "Kẹ́ńyà",
    "cuisine_ethiopian": "Etiópíà",
    "cuisine_moroccan": "Mòrókò",
    "cuisine_south_african": "Gúúsù Áfíríkà",
    "cuisine_jamaican": "Jàmáíkà",
    "cuisine_trinidadian": "Tírínídáàdì",
    "cuisine_lebanese": "Lẹ́bánọ́nì",
    "cuisine_turkish": "Tọ́kì",
    "cuisine_greek": "Gíríìsì",
    "cuisine_italian": "Ítálì",
    "cuisine_french": "Faransé",
    "cuisine_british": "Bìrìtìṣì",
    "cuisine_indian_south": "Gúúsù Íńdíà",
    "cuisine_indian_north": "Àríwá Íńdíà",
    "cuisine_pakistani": "Pákístà",
    "cuisine_japanese": "Jàpáànù",
    "cuisine_chinese": "Ṣáínà",
    "cuisine_korean": "Kòríà",
    "cuisine_vietnamese": "Vietinamu",
    "cuisine_thai": "Táìláǹdì",
    "cuisine_filipino": "Fílípínì",
    "cuisine_american": "Amẹ́ríkà",
    "cuisine_mexican": "Mẹ́síkò",
    "cuisine_brazilian": "Bùràsìlì",
    "cuisine_peruvian": "Perúù"
  },
  "dashboard": {
    "welcome": "Káàbọ̀ pàdà",
    "greeting": "Báwo",
    "goodMorning": "Ẹ kàárọ̀",
    "goodAfternoon": "Ẹ kàásán",
    "goodEvening": "Ẹ kàálẹ́",
    "tagline": "Ìṣe ìlera kékeré ń mú ìyípadà tó dúró",
    "microcopy": "Ìrìnàjò àlàáfíà rẹ ṣe pàtàkì.",
    "welcomeSubtitleMorning1": "Ìbẹ̀rẹ̀ ọjọ́ pẹ̀lú àlàáfíà.",
    "welcomeSubtitleMorning2": "A dúpẹ́ pé o wá lóòní àárọ̀.",
    "welcomeSubtitleMorning3": "Àwọn ìṣẹ̀lẹ̀ kékeré ṣe pàtàkì.",
    "welcomeSubtitleAfternoon1": "A nírètí pé ọjọ́ rẹ rọrùn.",
    "welcomeSubtitleAfternoon2": "Káàbọ̀ pàdà sí HealthLoop.",
    "welcomeSubtitleAfternoon3": "Fa èémí — ohun gbogbo dára.",
    "welcomeSubtitleEvening1": "A jọ pa ọjọ́ dé.",
    "welcomeSubtitleEvening2": "Ìparí ọjọ́ ní àlàáfíà.",
    "welcomeSubtitleEvening3": "Káàbọ̀ pàdà lálẹ́ òní.",
    "title": "Pẹpẹ ìlera ìdènà àìsàn rẹ",
    "subtitle": "Tọpinpin, kọ́, kí o sì gbéìgbésẹ̀ kí ìṣòro tó dàgbà",
    "summary": "Àkópọ̀ ìlera rẹ",
    "summaryDesc": "Real-time insights across prevention, education, engagement, and wellness",
    "comprehensiveSupport": "Comprehensive support across prevention, education, engagement, and wellness",
    "todayCheckIn": "Ìṣàyẹ̀wò òní",
    "quickActions": "Ìṣe Kíákíá",
    "healthOverview": "Àkópọ̀ Ìlera",
    "recentActivity": "Recent Activity",
    "viewAll": "Wo gbogbo rẹ̀",
    "preventiveHealth": "Ìlera ìdènà àìsàn",
    "preventiveHealthDesc": "Daily tracking, wellness monitoring & preventive alerts",
    "education": "Ẹ̀kọ́",
    "educationDesc": "Evidence-based insights, health articles & expert guidance",
    "engagement": "Ìfọkànsí",
    "engagementDesc": "Community challenges, habit tracking & social support",
    "wellness": "Àlàáfíà",
    "wellnessDesc": "Smart nutrition, lifestyle balance & holistic well-being",
    "todaysInsight": "Ìmọ̀ òní",
    "wellnessScore": "Ìdiwọn àlàáfíà",
    "healthStreak": "Lẹ́sẹẹsẹ ìlera",
    "days": "ọjọ́",
    "logHealth": "Kọ ìlera sílẹ̀",
    "getEducated": "Kọ́",
    "communityChallenge": "Community Challenge",
    "checkWellness": "Yẹ àlàáfíà wò",
    "verified": "Ó fìdíhàn",
    "joinCommunity": "Join Community",
    "personalizedPlan": "Ètò ti ara ẹni",
    "score": "Ìdiwọn",
    "checkIns": "check-ins",
    "habits": "habits",
    "preventive": "Preventive",
    "healthMetrics": "Health Metrics",
    "trackMetrics": "Track Metrics",
    "startTracking": "Start tracking",
    "logMetrics": "Log Metrics",
    "dailyInsight": "Daily Insight",
    "learnAbout": "Learn about preventive health today",
    "articlesAvailable": "articles available",
    "browseArticles": "Browse Articles",
    "currentStreak": "Current Streak",
    "keepGoing": "Keep it going!",
    "startStreak": "Start your streak",
    "checkIn": "Yẹ ara wò",
    "nutritionPlan": "Nutrition Plan",
    "mealsPlanned": "meals planned",
    "viewPlan": "View Plan",
    "planYourWeek": "Plan your week",
    "moodStress": "Ìbínú àti ìṣòro ọkàn",
    "howFeeling": "Báwo ni o ṣe rí?",
    "logWellness": "Log Wellness",
    "medications": "Òògùn",
    "noMeds": "No meds tracked",
    "addMedications": "Add your medications",
    "daysTracked": "Days Tracked",
    "noHabits": "No habits yet",
    "startTrackingHabits": "Start tracking habits",
    "insights": "Insights",
    "noInsights": "No insights yet",
    "completeFirstPlan": "Complete your first plan",
    "noCheckIns": "No check-ins yet",
    "startFirstCheckIn": "Start your first check-in"
  },
  "support": {
    "title": "Ìrànlọ́wọ́",
    "subtitle": "Wá ìdáhùn, kàn sí wa, tàbí ròyìn ìṣòro",
    "backToSettings": "Padà sí ètò",
    "privacyBanner": "A ń tọ́jú àwọn ìbéèrè ìrànlọ́wọ́ pẹ̀lú ìṣàdúgbé. Àlàyé ìlera rẹ wà ní àpamọ́.",
    "section1": "Apá 1",
    "section2": "Apá 2",
    "section3": "Apá 3",
    "section4": "Apá 4",
    "navHelpCenter": "Ibùdó ìrànlọ́wọ́",
    "navContact": "Kàn sí Ìrànlọ́wọ́",
    "navHealth": "Iṣẹ́ ìlera",
    "navTechnical": "Ìrànlọ́wọ́ tẹ́kínìkì",
    "helpCenterTitle": "Ibùdó ìrànlọ́wọ́",
    "helpCenterSubtitle": "Wá àwọn ìbéèrè tó wọ́pọ̀ kí o sì rí ìdáhùn yíyára.",
    "contactTitle": "Kàn sí Ìrànlọ́wọ́",
    "contactSubtitle": "Yan bí o ṣe fẹ́ rán ẹgbẹ́ wa.",
    "healthServicesTitle": "Iṣẹ́ ìlera",
    "healthServicesSubtitle": "Ní ìmọ̀ tó pé nípa òògùn àti àwọn alámọ̀ ìlera.",
    "technicalTitle": "Ìrànlọ́wọ́ tẹ́kínìkì",
    "technicalSubtitle": "Ròyìn àkóbá tàbí ìṣòro ìmọ̀-ẹrọ pẹ̀lú àlàyé tó pé.",
    "searchPlaceholder": "Wá ìbéèrè tó wọ́pọ̀…",
    "liveChat": "Ìjíròrò tààrà",
    "emailUs": "Fi ìméèlì ránṣẹ́",
    "callBack": "Schedule a callback",
    "sendMessage": "Fi iṣẹ́ ránṣẹ́",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "Orúkọ rẹ",
    "yourEmail": "Ìméèlì rẹ",
    "subject": "Kókó",
    "message": "Iṣẹ́",
    "phone": "Phone",
    "description": "Description",
    "submit": "Fi ránṣẹ́",
    "successTitle": "A ti gba iṣẹ́ rẹ",
    "successDescription": "A ó dáhùn lọ́jọ́ 1 – 2.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "Oúnjẹ Ọlọ́gbọ́n",
    "basedOnGoal": "Lórí èròngbà rẹ:",
    "personalizedData": "Personalized based on your recent health data",
    "evidenceBased": "Evidence-based nutrition as part of your preventive health plan",
    "todaysMealSuggestions": "Àbá oúnjẹ òní",
    "customize": "Tunṣe",
    "breakfast": "Oúnjẹ àárọ̀",
    "lunch": "Oúnjẹ ọ̀sán",
    "dinner": "Oúnjẹ alẹ́",
    "loadingBreakfast": "Loading breakfast...",
    "loadingLunch": "Loading lunch...",
    "loadingDinner": "Loading dinner...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "Pààrọ̀ oúnjẹ",
    "healthyOptionsNearYou": "Yíyàn ìlera lẹ́gbẹ̀ẹ́ rẹ",
    "enableLocation": "Enable location",
    "view": "Wò",
    "discoverOptions": "Discover healthy restaurants, grocery stores, and meal prep vendors near you",
    "cuisinesSelected": "cuisines selected",
    "cuisineSelected": "cuisine selected",
    "dietaryPrefs": "dietary prefs",
    "dietaryPref": "dietary pref",
    "customizeMeals": "Yan oúnjẹ tó bá ọ",
    "subtitleAdaptive": "Ètò oúnjẹ tó bọ́gbọ́n mu àṣà rẹ àti ìlera rẹ",
    "hideFavorites": "Bo àyànfẹ́",
    "viewFavorites": "Wo àyànfẹ́",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "Wo ètò kíkún",
    "exploreRecipes": "Wá oríṣiríṣi oúnjẹ"
  },
  "location": {
    "permissionTitle": "Find healthy options near you",
    "permissionDesc": "Used to recommend restaurants, grocery stores, and meal prep vendors aligned with your health goals.",
    "howToEnable": "How to enable:",
    "step1": "Click the lock icon 🔒 in your browser's address bar",
    "step2": "Find \"Location\" permissions",
    "step3": "Change to \"Allow\"",
    "step4": "Refresh this page",
    "refreshPage": "Refresh Page",
    "allowLocation": "Allow Location",
    "notNow": "Not now",
    "denied": "Location access was blocked. To see nearby healthy options, you'll need to enable location permissions.",
    "unavailable": "Location information is currently unavailable. Please check your device settings.",
    "error": "Unable to access your location. Please try again or check browser settings.",
    "unsupported": "Your browser doesn't support location services. Try using a modern browser like Chrome, Firefox, or Safari.",
    "accessRequired": "Location Access Required"
  },
  "womensHealth": {
    "title": "Women's Health",
    "description": "Track your cycle, log symptoms, and get personalized wellness tips based on your cycle phase",
    "cycleTracking": "Cycle Tracking",
    "symptomLogging": "Symptom Logging",
    "phaseInsights": "Phase Insights",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Insights",
    "tips": "Health Tips",
    "overview": "Overview",
    "history": "History",
    "startTracking": "Start Tracking Your Cycle"
  },
  "profile": {
    "title": "Àpèjúwe",
    "personalInfo": "Àlàyé ti ara ẹni",
    "healthProfile": "Àpèjúwe ìlera",
    "preferences": "Ààyò",
    "language": "Èdè",
    "selectLanguage": "Yan èdè",
    "notifications": "Ìfitóni",
    "privacy": "Aṣírí",
    "security": "Ààbò",
    "quickAccess": "Ìráyé kíákíá",
    "editProfile": "Ṣàtúnṣe àpèjúwe",
    "viewStats": "Wo iṣirò",
    "backToDashboard": "Padà sí pátákó",
    "womensHealthTitle": "Women's Health",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Health Reminders",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "Ìrànlọ́wọ́",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "Fún wa ní èrò rẹ",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "Ròyìn ìṣòro",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "Àlàyé pàtàkì",
    "fullName": "Orúkọ kíkún",
    "email": "Ìméèlì",
    "dateOfBirth": "Ọjọ́-ìbí",
    "gender": "Akọ tàbí abo",
    "height": "Gígà (cm)",
    "weight": "Ìwọ̀n (kg)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "account": "Account",
    "appearance": "Appearance",
    "languageSettings": "Language Settings",
    "changeLanguage": "Change Language",
    "languageNote": "Ojú-ìwòye náà yóò yípadà bí o bá ti yan èdè tuntun. Àwọn èdè ilẹ̀ Áfíríkà àti àwọn èdè tuntun ni a ṣe àmì 'Starter' sí — ẹ̀rọ ni ó túmọ̀ wọn láti jẹ́ kí wọn pọ̀, a sì ń dúró de àtúnyẹ̀wò láti ọwọ́ àwọn tó gbọ́ èdè náà dáadáa.",
    "languageUpdated": "Language updated successfully",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Ìtúmọ̀ láti ọwọ́ ẹ̀rọ — a ń dúró de àtúnyẹ̀wò láti ọwọ́ ọ̀mọ̀-èdè.",
    "regions": {
      "global": "Àgbáyé",
      "european": "Àwọn Èdè Ilẹ̀ Europe",
      "middleEastern": "Àwọn Èdè Àárín Gbùngbùn Ìlà-Oòrùn",
      "asian": "Àwọn Èdè Ilẹ̀ Asia",
      "african": "Àwọn Èdè Ilẹ̀ Áfíríkà"
    }
  },
  "search": {
    "triggerLabel": "Wá nǹkan nínú HealthLoop",
    "triggerHint": "Dán \"ìṣísẹ̀\", \"ilé-ìsègùn\" tàbí \"oyún\" wò",
    "triggerAriaLabel": "Ṣí ibi ìwárí gbogbo-gbòò",
    "placeholder": "Wá ohun èlò, olùtọpinpin, ìtìlẹ́yìn…",
    "inputAriaLabel": "Wá àwọn ohun èlò HealthLoop",
    "modalAriaLabel": "Wá nǹkan nínú HealthLoop",
    "close": "Sì dé",
    "clear": "Pa rẹ́",
    "clearAriaLabel": "Pa ohun tí o wá rẹ́",
    "recentSearches": "Àwọn ohun tí o wá láìpẹ́",
    "tryFor": "Dán ìwárí fún",
    "findFeatures": "Rí ohun èlò kankan láàárín ìṣẹjú àáyá.",
    "searchAcross": "Wá nínú",
    "and": "àti",
    "sections": {
      "home": "Ilé",
      "nutrition": "Oúnjẹ",
      "family": "Ẹbí",
      "services": "Àwọn Iṣẹ́",
      "support": "Ìtìlẹ́yìn",
      "profile": "Ìròyìn Rẹ"
    },
    "noMatchesFor": "Kò sí nǹkan fún \"{{query}}\"",
    "trySimpler": "Dán ọ̀rọ̀ tó rọrùn wò bíi ìṣísẹ̀, oúnjẹ tàbí onímọ̀.",
    "comingSoonBadge": "Ń bọ̀ lọ́nà",
    "escToClose": "láti tì í",
    "resultSingular": "{{count}} èsì",
    "resultPlural": "{{count}} àwọn èsì",
    "searchAcrossApp": "Wá nínú gbogbo ètò yìí"
  },
  "familyMember": {
    "confirmRemove": "Ṣé kí á yọ {{name}} kúrò nínú títọpinpin ìlera ẹbí?",
    "removed": "A ti yọ {{name}} kúrò nínú ẹbí",
    "removeFailed": "Ìyọkúrò kùnà",
    "viewDetails": "Wo Ìròyìn Kíkún",
    "edit": "Àtúnṣe",
    "remove": "Yọ kúrò",
    "yearsSuffix": "ọdún",
    "healthGoalsLabel": "Àwọn Àfojúsùn Ìlera:",
    "moreSuffix": "mìíràn",
    "activeInsights": "Àwọn Ìmọ̀ràn Tó Ń Ṣiṣẹ́",
    "viewAllInsights": "Wo gbogbo ìmọ̀ràn {{count}} →",
    "viewFullProfile": "Wo Ìròyìn Ìlera Kíkún",
    "lifeStage": {
      "infant": "Ìkókó (0-2)",
      "toddler": "Ọmọdé (2-5)",
      "child": "Ọmọ (6-12)",
      "adolescent": "Ọmọ ọ̀dọ́ (13-17)",
      "adult": "Àgbà (18-59)",
      "senior": "Àgbàlagbà (60+)",
      "unknown": "Kò mọ̀"
    }
  },
  "profileDeep": {
    "backToDashboard": "Padà sí pátákó",
    "profileCompletion": "Ìparí àpèjúwe",
    "healthSummary": "Àkópọ̀ ìlera",
    "sectionA": "Apá A",
    "sectionB": "Apá B",
    "sectionC": "Apá C",
    "sectionD": "Apá D",
    "personalDetails": "Àwọn àlàyé ti ara ẹni",
    "healthInformation": "Àwọn àlàyé ìlera",
    "accountSettings": "Ètò àkọsílẹ̀",
    "fullName": "Orúkọ kíkún",
    "email": "Ìméèlì",
    "dob": "Ọjọ́ ìbí",
    "gender": "Akọ tàbí abo",
    "genderPlaceholder": "bí: Obìnrin, Ọkùnrin, Mìíràn",
    "height": "Gígà (cm)",
    "heightPlaceholder": "bí: 170",
    "weight": "Ìwọ̀n (kg)",
    "weightPlaceholder": "bí: 70",
    "allergies": "Àwọn alèrégèèsì",
    "allergiesPlaceholder": "bí: Ẹ̀pà",
    "medicalConditions": "Àìsàn",
    "conditionsPlaceholder": "bí: Ipá ẹ̀jẹ̀ gíga",
    "medications": "Òògùn",
    "medicationsPlaceholder": "bí: Lisinopril 10mg, lójoojúmọ́",
    "emergencyContact": "Ẹni tí á máa pè ní kíákíá",
    "emergencyOptional": "(kì í ṣe dandan)",
    "emergencyPlaceholder": "bí: Ìyá +234-803-000-0000",
    "emergencyNote": "A máa fi kún nikan tí o bá fi ààyè gba pípín pẹ̀lú dókítà.",
    "saveChanges": "Fi ìyípadà pamọ́",
    "saving": "Ó ń fipamọ́…",
    "editProfile": "Ṣàtúnṣe àpèjúwe",
    "cancelEditing": "Fagilé àtúnṣe",
    "healthScore": "Ìdiwọn ìlera",
    "streak": "Ìṣe lẹ́sẹẹsẹ",
    "streakDays": "ọjọ́ {{n}}",
    "memberSince": "Ọmọ-ẹgbẹ́ láti",
    "remindersActive": "Ìránti tó ń ṣiṣẹ́",
    "conditionsTracked": "Àìsàn tí á ń tọpinpin",
    "nextAgenda": "Ohun tókàn lórí ètò rẹ",
    "notificationsReminders": "Ìfitóni àti ìránti",
    "notificationsRemindersDesc": "Ṣe ètò àkókò àti àwọn ọ̀nà ìránti rẹ",
    "emailNudges": "Ìránti ìméèlì",
    "emailNudgesDesc": "Àwọn ìránti pẹ̀lẹ́ àti àkójọ ọ̀sẹ̀ọ̀sẹ̀",
    "on": "Ti ṣíṣẹ́",
    "paused": "Dúró díẹ̀",
    "privacySecurity": "Ìpamọ́ àti ààbò",
    "privacySecurityDesc": "Yí ọ̀rọ̀-ìṣírò padà láti dáàbò bo àkọsílẹ̀ rẹ",
    "preferencesTitle": "Ààyò",
    "preferencesDesc": "Èdè, agbègbè, àti ti ara ẹni",
    "supportHelp": "Ìrànlọ́wọ́",
    "supportHelpDesc": "Rí ìdáhùn kí o sì kàn sí wa",
    "giveFeedback": "Fún wa ní èrò rẹ",
    "giveFeedbackDesc": "Sọ ohun tí a lè ṣe dáradára",
    "reportProblem": "Ròyìn ìṣòro",
    "reportProblemDesc": "Ṣé o ríbu? Sọ fún wa",
    "adminInsights": "Ìmọ̀ alábojútó",
    "adminInsightsDesc": "Ìtúpalẹ̀ ìfọkànsí",
    "adminBadge": "Alábojútó",
    "shareWithClinician": "Pín pẹ̀lú dókítà",
    "shareWithClinicianDesc": "Ìwé kíkà nìkan · ó máa parí lẹ́ẹ̀kọ̀ọ̀kan · o lè fagilé nígbàkígbà",
    "share": "Pín",
    "profileMayBeOutOfDate": "Àpèjúwe lè jẹ́ àtijọ́",
    "profileMayBeOutOfDateDesc": "Jẹ́ kí àkọsílẹ̀ ìlera rẹ tó péye fún ìmọ̀ràn tó dára — àyípadà kékeré (ìwọ̀n, òògùn) wúlò.",
    "updateNow": "Tún ṣe ní báyìí",
    "profileUpdateError": "A kò lè tún ààyò rẹ ṣe. Gbìyànjú lẹ́ẹ̀kansí.",
    "healthLoopUser": "Olùlò HealthLoop",
    "updatedLabel": "A ti tún ṣe",
    "noEntries": "Kò sí ìkọ̀wé síbẹ̀.",
    "completionComplete": "Àpèjúwe rẹ ti kún. A lè fún ọ ní ìtọ́sọ́nà tó dára jùlọ. 💚",
    "completionAlmostThere": "Ó ti ku díẹ̀. Àlàyé díẹ̀ síi yóò ràn wá lọ́wọ́.",
    "completionInProgress": "Pari àpèjúwe rẹ fún ìmọ̀ràn àlàáfíà tó dára.",
    "justNow": "báyìí",
    "minAgo": "ìṣẹ́jú {{n}} kọjá",
    "minsAgo": "ìṣẹ́jú {{n}} kọjá",
    "hourAgo": "wákàtí {{n}} kọjá",
    "hoursAgo": "wákàtí {{n}} kọjá",
    "dayAgo": "ọjọ́ {{n}} kọjá",
    "daysAgo": "ọjọ́ {{n}} kọjá",
    "checkinDueToday": "Ìṣàyẹ̀wò òní láti ṣe",
    "checkinDueTonight": "Ìṣàyẹ̀wò alẹ́ òní láti ṣe"
  },
  "supportDeep": {
    "backToSettings": "Padà sí ètò",
    "quickNavAria": "Àwọn apá ìrànlọ́wọ́",
    "searchPlaceholder": "Wá ìrànlọ́wọ́…",
    "searchAria": "Wá ìbéèrè tó wọ́pọ̀",
    "resultsCount": "àbájáde {{n}}",
    "resultsCountPlural": "àwọn àbájáde {{n}}",
    "questionsCount": "ìbéèrè {{n}}",
    "liveChatTitle": "Ìjíròrò tààrà",
    "liveChatDesc": "Bá wa sọ̀rọ̀ tààrà · Aje–Eti 9am–6pm",
    "startChat": "Bẹ̀rẹ̀ ìjíròrò",
    "liveChatSoonToast": "Ìjíròrò tààrà yóò bẹ̀rẹ̀ láìpẹ́. Fún báyìí, ìméèlì ń ṣiṣẹ́ dáradára.",
    "emailUsTitle": "Fi ìméèlì ránṣẹ́",
    "emailUsDesc": "Ìdáhùn láàrín wákàtí 24–48",
    "copy": "Daakọ",
    "emailCopied": "A ti daakọ ìméèlì.",
    "contactFormTitle": "Fọ́ọ̀mù ìbáṣepọ̀",
    "contactFormDesc": "Fi iṣẹ́ ránṣẹ́ — a ó dáhùn nípasẹ̀ ìméèlì.",
    "yourNameLabel": "Orúkọ rẹ *",
    "namePlaceholder": "Adé Olú",
    "yourEmailLabel": "Ìméèlì rẹ *",
    "emailPlaceholder": "ade@apẹẹrẹ.com",
    "subjectOptional": "Kókó (kì í ṣe dandan)",
    "subjectPlaceholder": "Báwo ni a ṣe lè ràn ọ́ lọ́wọ́?",
    "messageLabel": "Iṣẹ́ *",
    "messagePlaceholder": "Sọ fún wa ní ṣókí ohun tí o nílò.",
    "sending": "Ó ń ránṣẹ́…",
    "sendMessage": "Fi iṣẹ́ ránṣẹ́",
    "messageSent": "A ti fi iṣẹ́ ránṣẹ́",
    "messageSentDesc": "A ó dáhùn láàrín wákàtí 24–48.",
    "callbackTitle": "Béèrè ìpè padà",
    "callbackDesc": "A ó pè ọ́ padà nígbà tí ó bá rọrùn fún ọ.",
    "phoneLabel": "Nọ́mbà fóònù *",
    "phonePlaceholder": "+234 803 000 0000",
    "preferredTimeLabel": "Àkókò tí o fẹ́ (kì í ṣe dandan)",
    "preferredTimePlaceholder": "bí: ní ọ̀la lẹ́yìn ọ̀sán",
    "reasonLabel": "Ìdí (kì í ṣe dandan)",
    "reasonPlaceholder": "Ní ṣókí, kí ni o fẹ́ jíròrò?",
    "submitting": "Ó ń ránṣẹ́…",
    "requestCallback": "Béèrè ìpè padà",
    "callbackRequested": "A ti béèrè ìpè padà",
    "callbackRequestedDesc": "A ó kàn sí ọ láàrín wákàtí 24.",
    "medicationSupport": "Ìrànlọ́wọ́ òògùn",
    "medicationSupportDesc": "Tọpinpin oogun, ìfikún, àti ìránti.",
    "goToMedications": "Lọ sí àwọn òògùn →",
    "specialistConsultation": "Ìjíròrò pẹ̀lú alámọ̀",
    "specialistConsultationDesc": "Bá dókítà sọ̀rọ̀ fún ìmọ̀ràn ìlera ti ara ẹni.",
    "connectExpert": "Bá alámọ̀ sọ̀rọ̀ →",
    "videoConsult": "Ìjíròrò fídíò",
    "videoConsultDesc": "Ṣe ètò ìpàdé fídíò pẹ̀lú alámọ̀.",
    "bookConsultation": "Ṣe ètò ìjíròrò →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop ń ràn ọ́ lọ́wọ́ ojoojúmọ́ — kò rọ́pò ìtọ́jú ilé ìwòsàn tó pàjáwìrì. Nígbà pàjáwìrì kàn sí àwọn iṣẹ́ ìwòsàn lágbègbè rẹ.",
    "categoryLabel": "Ẹ̀ka",
    "catBug": "Àkóbá / Àṣìṣe",
    "catPerformance": "Iṣẹ́ tó lọ́ra",
    "catFeature": "Ohun tí kò ṣiṣẹ́",
    "catUi": "Ìṣòro àkàwé",
    "catOther": "Òmíràn",
    "issueTitle": "Àkọ́lé ìṣòro *",
    "issueTitlePlaceholder": "Ṣókí ohun tó ṣẹlẹ̀",
    "detailedDescription": "Àlàyé kíkún *",
    "detailedDescriptionPlaceholder": "Kí ló ṣẹlẹ̀? Kí ni o ń ṣe? Àwọn ìgbésẹ̀ ṣe ìtúnṣẹlẹ̀ ràn wá lọ́wọ́ púpọ̀.",
    "autoAttachNote": "A ó so ìmọ̀ ẹ̀rọ, browser àti window mọ́ pọ̀.",
    "submitReport": "Fi ìròyìn ránṣẹ́",
    "reportSubmitted": "A ti gba ìròyìn rẹ",
    "reportSubmittedDesc": "Ẹgbẹ́ wa ti bẹ̀rẹ̀.",
    "fillAllFields": "Jọ̀wọ́ kún àwọn àyè dandan",
    "problemReportSubmittedToast": "A ti gba ìròyìn ìṣòro. A ó wá ìmọ̀ rẹ̀ a sì padà sí ọ.",
    "messageSentToast": "A ti gba iṣẹ́ rẹ. A ó dáhùn láàrín wákàtí 24–48.",
    "callRequestedToast": "A ti gba ìbéèrè ìpè rẹ. A ó kàn sí ọ láàrín wákàtí 24.",
    "submitFailGeneric": "Ó kùnà láti ránṣẹ́. Gbìyànjú lẹ́ẹ̀kansí tàbí kọ̀wé sí {{email}}.",
    "submitFailContact": "Ó kùnà láti ránṣẹ́. Kọ̀wé tààrà sí {{email}}."
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "healthProfile": "Àpèjúwe ìlera",
    "notifications": "Ìfitóni",
    "familyAccounts": "Àkọsílẹ̀ ẹbí",
    "settings": "Ètò",
    "logout": "Jáde",
    "allCaughtUp": "O ti dé ibi gbogbo.",
    "weekInReview": "Ọ̀sẹ̀ rẹ ní àyẹ̀wò",
    "dismissNotification": "Pa ìfitóni",
    "dismissWeeklyDigest": "Pa àkójọ ọ̀sẹ̀",
    "notificationsAria": "Ìfitóni",
    "profileMenuAria": "Ṣí àkójọ àpèjúwe",
    "loadingWellness": "Ó ń kó àkópọ̀ àlàáfíà rẹ",
    "nextTip": "Ìmọ̀ràn tókàn",
    "todayAtGlance": "Òní ní ojú kan",
    "healthScoreLabel": "Ìdiwọn ìlera",
    "currentStreakLabel": "Ìṣe lẹ́sẹẹsẹ",
    "todaysProgress": "Ìtẹ̀síwájú òní",
    "insightForYou": "Ìmọ̀ràn fún ọ",
    "checkMyHealthRisk": "Yẹ ewu ìlera mi wò",
    "quickAccess": "Ìráyé kíákíá",
    "familyCare": "Ìtọ́jú ẹbí",
    "healthLibrary": "Ìkàwé ìlera",
    "myHealthData": "Àlàyé ìlera mi",
    "askQuestion": "Béèrè ìbéèrè",
    "dashLoadError": "A kò lè kó pátákó rẹ. Gbìyànjú lẹ́ẹ̀kansí.",
    "taskUpdateError": "A kò lè tún iṣẹ́ ṣe. Gbìyànjú lẹ́ẹ̀kansí.",
    "perfectDay": "Ọjọ́ tó péye! 🎉 Ìṣe lẹ́sẹẹsẹ ti gùn.",
    "letsStart": "Bẹ̀rẹ̀",
    "yourNextStepToday": "Ìgbésẹ̀ tókàn lóòní",
    "completeDailyCheck": "Ṣe ìṣàyẹ̀wò ìlera ojoojúmọ́",
    "startDailyCheck": "Bẹ̀rẹ̀ ìṣàyẹ̀wò",
    "viewAll": "Wo gbogbo rẹ̀",
    "graceProtected": "Ìdáàbòbò àánú",
    "todaysHealthRecommendations": "Ìmọ̀ràn ìlera òní",
    "updateViaCheck": "Tún ṣe nípa ìṣàyẹ̀wò",
    "healthInsight": "Ìmọ̀ ìlera",
    "riskCheckSubtext": "Rí àwọn ìmọ̀ràn ìlera ti ara ẹni ní àárín ìṣẹ́jú-àáyá",
    "foodDiet": "Oúnjẹ",
    "healthScoreNew": "Ìdiwọn ìlera · Tuntun",
    "letsBuildScore": "Jẹ́ ká kọ́ ìdiwọn ìlera rẹ pọ̀",
    "oneHealthyHabitAtATime": "Ìṣe tó dára kọ̀ọ̀kan.",
    "nextCheck": "Ìṣàyẹ̀wò tókàn:",
    "todayAt8pm": "lónìí ní 8:00 alẹ́",
    "wellnessTipForYou": "Ìmọ̀ràn àlàáfíà òní · Fún ọ",
    "wellnessTipForFactor": "Ìmọ̀ràn àlàáfíà òní · Fún {{factor}} rẹ",
    "logged": "Ti gba",
    "gotIt": "Ti mọ̀ ọ́ 👍",
    "gladToSeeYou": "Inú wa dùn láti rí ọ lónìí 💚",
    "takesLessThan60Sec": "Kò tó ìṣẹ́jú-àáyá 60",
    "scoreReadyWhenYou": "A ti ṣetán nígbà tó wù ọ́",
    "scoreCompleteFirstCheck": "Ṣe ìṣàyẹ̀wò àkọ́kọ́ rẹ láti gba ìmọ̀ràn ti ara ẹni.",
    "scoreExcellent": "Ìtayọ",
    "scoreSupportExcellent": "Ó dára gan-an lónìí. Tẹsiwaju!",
    "scoreGood": "Dáradára",
    "scoreSupportGood": "O ń ṣe dáradára. Tọ́jú ìṣe ìlera rẹ.",
    "scoreModerate": "Ó wà",
    "scoreSupportModerate": "Ohun gbogbo ṣì wà, sùgbọ́n àwọn àyè kan nílò ìfọkànsí.",
    "scoreNeedsAttention": "Nílò ìfọkànsí",
    "scoreSupportNeedsAttention": "Ìlera rẹ nílò ìfọkànsí lónìí. Àyípadà kékeré lè ràn ọ́ lọ́wọ́."
  },
  "emailVerify": {
    "bannerWithEmail": "Jọ̀wọ́ jẹ́rìí ìméèlì rẹ ({{email}}) ká lè dáàbò bo àkọsílẹ̀ rẹ kí o sì gba ìránti rẹ.",
    "bannerNoEmail": "Jọ̀wọ́ jẹ́rìí ìméèlì rẹ ká lè dáàbò bo àkọsílẹ̀ rẹ.",
    "sending": "Ó ń ránṣẹ́…",
    "resend": "Tún ìméèlì ránṣẹ́",
    "sentToast": "Ìméèlì ìjẹ́rìí ti ránṣẹ́. Wo apo ìméèlì rẹ.",
    "sendFailToast": "A kò lè ránṣẹ́. Gbìyànjú lẹ́yìn náà."
  },
  "forgotPassword": {
    "title": "Ṣé o gbàgbé ọ̀rọ̀-ìṣírò rẹ?",
    "subtitle": "Má wahala! Tẹ ìméèlì rẹ, a ó fi ìtọ́nisọ́nà ránṣẹ́.",
    "emailLabel": "Àdírẹ́sì ìméèlì",
    "emailPlaceholder": "imeeli.re@apẹẹrẹ.com",
    "sendResetLink": "Fi ọna ránṣẹ́",
    "sending": "Ó ń ránṣẹ́…",
    "backToLogin": "Padà sí ìwọlé",
    "resendLink": "Tún ìméèlì ránṣẹ́",
    "successTitle": "Wo ìméèlì rẹ",
    "successBody": "Bí àkọsílẹ̀ kan bá wà fún {{email}}, a ti fi ọna ìtúnpadà ránṣẹ́.",
    "linkExpires": "Ọna náà yóò parí ní ìṣẹ́jú 30.",
    "successToast": "Wo ìméèlì rẹ fún ìtọ́nisọ́nà ìtúnpadà",
    "errEmptyEmail": "Jọ̀wọ́ tẹ àdírẹ́sì ìméèlì rẹ",
    "errInvalidEmail": "Jọ̀wọ́ tẹ àdírẹ́sì ìméèlì tó péye",
    "errNetwork": "A kò lè dé sí olùpèsè. Yẹ ìsopọ̀ rẹ wò.",
    "errGeneric": "A kò lè ránṣẹ́. Gbìyànjú lẹ́ẹ̀kansí tàbí kàn sí ìrànlọ́wọ́."
  },
  "resetPassword": {
    "title": "Ṣe ọ̀rọ̀-ìṣírò tuntun",
    "subtitle": "Ṣẹ̀dá ọ̀rọ̀-ìṣírò tó lágbára fún àkọsílẹ̀ rẹ",
    "newPasswordLabel": "Ọ̀rọ̀-ìṣírò tuntun",
    "newPasswordPlaceholder": "Tẹ ọ̀rọ̀-ìṣírò tuntun",
    "confirmPasswordLabel": "Fi ìdánilójú ọ̀rọ̀-ìṣírò han",
    "confirmPasswordPlaceholder": "Fi ìdánilójú ọ̀rọ̀-ìṣírò tuntun han",
    "requirementsHint": "Ó gbọ́dọ̀ jẹ́ ìwé 8 pẹ̀lú ńlá, kéré, àti òǹkà",
    "resetPassword": "Tún ṣe ọ̀rọ̀-ìṣírò",
    "resetting": "Ó ń tún ṣe…",
    "successTitle": "Ọ̀rọ̀-ìṣírò ti yí padà!",
    "successBody": "O lè wọlé báyìí pẹ̀lú ọ̀rọ̀-ìṣírò tuntun rẹ.",
    "successToast": "Ọ̀rọ̀-ìṣírò ti yí padà ní àṣeyọrí!",
    "goToLogin": "Lọ sí ìwọlé",
    "invalidLinkTitle": "Ọna kò péye",
    "invalidLinkBody": "Ọna ìtúnpadà yìí kò péye tàbí ó ti parí.",
    "requestNewLink": "Béèrè ọna tuntun",
    "showPassword": "Fihàn ọ̀rọ̀-ìṣírò",
    "hidePassword": "Pa ọ̀rọ̀-ìṣírò mọ́",
    "errInvalidLink": "Ọna ìtúnpadà kò péye",
    "errMismatch": "Ọ̀rọ̀-ìṣírò kò bámu",
    "errTooShort": "Ọ̀rọ̀-ìṣírò gbọ́dọ̀ jẹ́ ìwé mẹ́jọ àbí jù",
    "errExpiredToken": "Ọna yìí ti parí tàbí kò péye. Béèrè tuntun.",
    "errNetwork": "A kò lè dé sí olùpèsè. Yẹ ìsopọ̀ rẹ wò.",
    "errGeneric": "Ìtúnpadà kùnà. Gbìyànjú lẹ́ẹ̀kansí."
  },
  "tips": {
    "water1": "Mímu omi láàrín ìṣẹ́jú 30 lẹ́yìn jíjí lè mú àyé omi àti agbára sí i.",
    "water2": "Ife omi kan ṣáájú oúnjẹ kọ̀ọ̀kan jẹ́ ọ̀nà pẹ̀lẹ́ láti dénú òùngbẹ.",
    "water3": "Bíbá lemon ojú kan tàbí ewé mìnt sí kún sí omi mu mímu omi yìí ní ìgbádùn.",
    "meals1": "Èkún àfikún tó ní irúgbìn lójoojúmọ́ ń ṣètìlẹ́yìn fún ìlera inú àti ọkàn.",
    "meals2": "Ìmu ọ̀mọ̀ wàrà tàbí irúgbìn pẹ̀lú oúnjẹ òwúrọ̀ ń mú agbára rẹ dúró ní òwúrọ̀.",
    "meals3": "Èso pípé sàn ju omi èso lọ — okun ń mú ṣúgà ẹ̀jẹ̀ dúró pẹ̀lẹ́.",
    "steps1": "Ìrìn ìṣẹ́jú 10 lẹ́yìn oúnjẹ ń ràn ara rẹ lọ́wọ́ láti rọ ṣúgà jẹ́.",
    "steps2": "Ìnà ara ìṣẹ́jú 5 ní òwúrọ̀ lè dín ìpá kù àti mú ọjọ́ rẹ rọ.",
    "steps3": "Gígun àtẹ́gùn lẹ́ẹ̀kan lójúmọ́ máa mú agbára ọkàn pọ̀ sí i lójoojúmọ́.",
    "sleep1": "Dídín ìmọ́lẹ̀ kù wákàtí kan ṣáájú sísùn ń ràn ara lọ́wọ́ láti sùn jíníjíní.",
    "sleep2": "Àkókò jíjí dúró — pàápàá lọ́jọ́ Sátidé—ń tọ́jú ìṣẹ́lẹ̀ oorun rẹ.",
    "sleep3": "Ìṣẹ́jú 10 nínú ìmọ́lẹ̀ òwúrọ̀ ń ṣètò ìrìnsẹ̀ oorun rẹ ní ti ara.",
    "general1": "Ìṣẹ́jú méjì ti èémí pẹ̀lẹ́ lè dín ìbànújẹ́ kù àti mú ìfọ́kànsí dúró.",
    "general2": "Ṣàkíyèsí àkókò ìfọwọ́sí kan lónìí — àwọn ìṣẹ́gun kékeré dín kún sí pọ̀.",
    "general3": "O wá lónìí. Ìṣe yẹn ni ó mú gbogbo ìṣe mìíràn ṣe rọ̀rùn."
  },
  "factors": {
    "hydration": "omi mímu",
    "nutrition": "oúnjẹ",
    "movement": "ìṣe ara",
    "sleep": "oorun"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Ó kùnà láti kó àwọn àbá oúnjẹ",
    "prefsSaved": "A ti gba àwọn ààyò rẹ! A ń tún àwọn oúnjẹ ṣe...",
    "prefsSaveFail": "Ó kùnà láti gba àwọn ààyò",
    "newOptionsFail": "Ó kùnà láti kó àwọn àbá tuntun",
    "invalidZip": "Jọ̀wọ́ tẹ kóòdù ìfọwọ́sí to péye (òǹkà 5)",
    "noVendorsArea": "Kò sí oníṣòwò lágbègbè yìí síbẹ̀. À ń mú àgbègbè jù síi!",
    "vendorsFetchFail": "Ó kùnà láti rí àwọn oníṣòwò",
    "selectVendorFirst": "Yan oníṣòwò ìpèsè lákọ̀ọ́kọ́",
    "removedFromCart": "A ti yọ kúrò nínú gbígbé",
    "orderPlaced": "Iṣẹ́ rẹ ti dé! 🎉",
    "enterZipFirst": "Tẹ kóòdù ìfọwọ́sí rẹ ní ibi ìpèsè lákọ̀ọ́kọ́",
    "mealNotAvailable": "Oúnjẹ yìí kò sí fún ìpèsè ní agbègbè rẹ síbẹ̀",
    "mealUnavailable": "Oúnjẹ yìí kò sí lọ́dọ̀ oníṣòwò tó wà lẹ́gbẹ̀ẹ́ rẹ",
    "vendorOptionsFail": "Ó kùnà láti kó àwọn àbá oníṣòwò",
    "favoriteSaveFail": "Ó kùnà láti gba àyànfẹ́",
    "removedFromFavorites": "A ti yọ kúrò nínú àyànfẹ́",
    "favoriteRemoveFail": "Ó kùnà láti yọ àyànfẹ́ kúrò",
    "cartEmpty": "Gbígbé rẹ kò ní nǹkan",
    "noMealOptions": "Kò sí àbá oúnjẹ",
    "loadingOptions": "Ó ń kó àwọn àbá oúnjẹ...",
    "selectPreferences": "Yan ààyò oúnjẹ rẹ",
    "mealBuilder": "Ṣètò oúnjẹ",
    "myFavorites": "Àyànfẹ́ mi",
    "myFavoriteMeals": "Àwọn oúnjẹ tó wù mí",
    "noFavoritesYet": "Kò sí oúnjẹ àyànfẹ́ síbẹ̀!",
    "price": "Iye",
    "delivery": "Ìpèsè",
    "deliveryFee": "Owó ìpèsè",
    "distance": "Ìjìnnà",
    "subtotal": "Àpapọ̀ kéréje",
    "total": "Àpapọ̀",
    "orderNumber": "Nọ́mbà àṣẹ",
    "vendor": "Oníṣòwò",
    "totalAmount": "Iye àpapọ̀",
    "estimatedDelivery": "Àkókò ìpèsè",
    "whyThisMeal": "Kí ló dé tí oúnjẹ yìí",
    "selectThisMeal": "Yan oúnjẹ yìí",
    "swapMeal": "Pààrọ̀ oúnjẹ",
    "orderThisMeal": "Bèèrè fún oúnjẹ yìí",
    "notAvailableNearYou": "Kò sí nítòsí rẹ",
    "tryAdjustingPrefs": "Gbìyànjú láti tún ààyò oúnjẹ rẹ ṣe láti rí àbá",
    "myMealPlanSummary": "Ètò oúnjẹ mi",
    "saveCompletePlan": "Fi ètò gbogbo pamọ́",
    "yourFoodPreferences": "Ààyò oúnjẹ rẹ",
    "editPreferences": "Ṣàtúnṣe ààyò",
    "healthyMealDelivery": "Ìpèsè oúnjẹ aládùn",
    "enableDelivery": "Mú ìpèsè ṣiṣẹ́",
    "enterZipCode": "Tẹ kóòdù ìfọwọ́sí rẹ láti rí oúnjẹ tó wà",
    "savePreferences": "Fi ààyò pamọ́",
    "quickAccessSavedMeals": "Ìráyé kíákíá sí oúnjẹ tí o ti fipamọ́",
    "saveMealsFromBuilder": "Fi oúnjẹ pamọ́ láti inú tabu Mjengo wa Mlo",
    "chooseVendor": "Yan oníṣòwò láti bèèrè fún oúnjẹ yìí",
    "yourCart": "Gbígbé rẹ",
    "addMealsToStart": "Fi oúnjẹ kún láti àwọn àbá tó wà nísàlẹ̀",
    "orderPlacedDesc": "Aṣẹ oúnjẹ aládùn rẹ ti dé",
    "continueShopping": "Tẹsiwaju ọjà",
    "trackOrder": "Tọpinpin aṣẹ",
    "healthyStoresTitle": "Àwọn Ilé-ìtajà Oúnjẹ Aṣaralóore nítòsí",
    "healthyStoresIntro": "Àwọn irúfẹ́ ilé-ìtajà tó bá àṣà wa mu nítòsí rẹ — fún ìmọ̀ràn, kì í ṣe fún títà.",
    "healthyStoresGuidanceTitle": "Ìtọ́sọ́nà fún rírà oúnjẹ aṣaralóore",
    "healthyStoresDisclaimer": "HealthLoop ń pèsè ìmọ̀ràn gbogbo-gbòò fún ìlera àti ìwúrí fún rírà oúnjẹ nìkan — kì í ṣe fún ìtọ́jú ìṣègùn tàbí ìlànà oúnjẹ àkànṣe.",
    "healthyStores": {
      "organic": {
        "type": "Ilé-ìtajà oúnjẹ àdánidá (Organic)",
        "description": "Àwọn oúnjẹ tuntun, tí kò ní oògùn apakòkòrò àti àwọn ohun èlò tí a kò fọwọ́ kàn púpọ̀.",
        "tags": [
          "Oúnjẹ Àdánidá",
          "Èso Tuntun"
        ]
      },
      "farmers": {
        "type": "Ọjà àgbẹ̀",
        "description": "Àwọn èso, ẹfọ́, àti oúnjẹ àṣà tí a ṣẹ̀ṣẹ̀ kárìí látọ̀dọ̀ àwọn àgbẹ̀.",
        "tags": [
          "Àdúgbò",
          "Àkókò"
        ]
      },
      "african": {
        "type": "Ilé-ìtajà oúnjẹ ilẹ̀ Áfíríkà",
        "description": "Iṣu, ọ̀pẹ̀tẹ̀, ẹfọ́ títù, ẹmu, àti àwọn oúnjẹ àṣà láti Ìwọ̀-oòrùn àti Ìlà-oòrùn Áfíríkà.",
        "tags": [
          "Àṣà",
          "Èso Tuntun"
        ]
      },
      "caribbean": {
        "type": "Ọjà oúnjẹ àdánidá ti Caribbean",
        "description": "Ẹfọ́ Callaloo, gbaguda, ata rodo, ackee, àti àwọn oúnjẹ erékùṣù mìíràn.",
        "tags": [
          "Àṣà",
          "Oúnjẹ Àdánidá"
        ]
      },
      "asian": {
        "type": "Ilé-ìtajà ẹfọ́ ti Asia",
        "description": "Bok choy, daikon, lotus root, tofu, àti àwọn ewébẹ̀ tuntun ti Asia.",
        "tags": [
          "Àṣà",
          "Èso Tuntun"
        ]
      },
      "halal": {
        "type": "Ọjà oúnjẹ aṣaralóore ti Halal",
        "description": "Ẹran tí a fọwọ́sí gẹ́gẹ́ bí Halal, ẹfọ́ tuntun àti àwọn ohun èlò oúnjẹ àṣà.",
        "tags": [
          "Halal",
          "Àṣà"
        ]
      },
      "mediterranean": {
        "type": "Ọjà oúnjẹ àdánidá ti Mediterranean",
        "description": "Òróró ólífì, ẹ̀wà, ewébẹ̀ tuntun, àti àwọn oúnjẹ àṣà Mediterranean.",
        "tags": [
          "Àṣà",
          "Oúnjẹ Àdánidá"
        ]
      },
      "wellness": {
        "type": "Ilé-ìtajà oúnjẹ fún ìlera",
        "description": "Àwọn oúnjẹ àdánidá tí a yàn ní tìpátìpá, oúnjẹ tí a fi ewébẹ̀ ṣe, àti àwọn ohun èlò tó mọ́.",
        "tags": [
          "Oúnjẹ Àdánidá",
          "Oúnjẹ Ewébẹ̀"
        ]
      }
    },
    "healthyShoppingTips": [
      "Bẹ̀rẹ̀ rírà láti ìsọ̀tíì — àwọn èso tuntun, ẹran tó dára àti àwọn oúnjẹ mímọ́ máa ń wà ní etíle.",
      "Yan oúnjẹ tó jẹ́ àdánidá ju àwọn èyí tí a ti ṣe lọ́pọ̀lọpọ̀ nínú ilé-iṣẹ́.",
      "Yan àwọn oúnjẹ àkókò ní àdúgbò rẹ — wọ́n máa ń tutù, wọ́n ń din owó kù, wọ́n sì ní èròjà nínú.",
      "Béèrè lọ́wọ́ àwọn olùtà nípa ibi tí oúnjẹ ti wá — ọ̀pọ̀ yóò fẹ́ láti sọ fún ọ."
    ]
  },
  "messages": {
    "success": "Success!",
    "error": "Error",
    "saved": "Saved successfully",
    "updated": "Updated successfully",
    "deleted": "Deleted successfully",
    "confirmDelete": "Are you sure you want to delete this?",
    "networkError": "Network error. Please try again.",
    "somethingWrong": "Something went wrong",
    "failedToLoad": "Failed to load dashboard",
    "offlineMode": "Offline mode - showing limited data",
    "locationDenied": "Location access denied. Check browser settings to enable.",
    "locationUnavailable": "Location information unavailable",
    "locationTimeout": "Location request timed out. Please try again.",
    "locationError": "Unable to access location",
    "locationGranted": "Location access granted! Showing nearby options",
    "locationNotSupported": "Location services not supported by your browser",
    "requestingLocation": "Requesting location access..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Preventive Health Tracker",
    "educationHub": "Education Hub",
    "engagementWidget": "Engagement Widget",
    "wellnessCheckIn": "Wellness Check-In",
    "todaysMetrics": "Today's Metrics",
    "bloodPressure": "Blood Pressure",
    "heartRate": "Heart Rate",
    "weight": "Weight",
    "sleep": "Sleep",
    "waterIntake": "Water Intake",
    "exercise": "Exercise",
    "logMetric": "Log Metric",
    "viewHistory": "View History"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Health Reminders",
    "subtitle": "Stay on track with personalized health notifications",
    "breakfast": "Breakfast Reminder",
    "lunch": "Lunch Reminder",
    "dinner": "Dinner Reminder",
    "water": "Water Intake",
    "movement": "Movement Break",
    "sleep": "Sleep Reminder",
    "wellness": "Wellness Check-In",
    "healthLogging": "Health Logging",
    "annualCheckup": "Annual Checkup",
    "enable": "Enable",
    "disable": "Disable",
    "customize": "Customize Time",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "Darapọ̀ mọ́ HealthLoop",
    "subtitle": "Bẹ̀rẹ̀ ìrìnàjò ìdènà àìsàn rẹ lóòní",
    "fullName": "Orúkọ kíkún",
    "email": "Ìméèlì",
    "password": "Ọ̀rọ̀-ìṣírò",
    "confirmPassword": "Fi ìdánilójú ọ̀rọ̀-ìṣírò han",
    "createAccount": "Ṣẹ̀dá àkọsílẹ̀",
    "haveAccount": "Ṣé o ti ní àkọsílẹ̀?",
    "signIn": "Wọlé",
    "creating": "Ó ń ṣẹ̀dá àkọsílẹ̀...",
    "passwordTooShort": "Ọ̀rọ̀-ìṣírò gbọ́dọ̀ jẹ́ ìwé mẹ́jọ àbí jù",
    "setupBiometric": "Ṣètò ìwọlé biometric",
    "setupBiometricDesc": "Lo ìka rẹ, Face ID, tàbí Windows Hello fún ìwọlé tó yáraju, tó sì ní ààbò",
    "setupNow": "Ṣètò báyìí",
    "skipForNow": "Lẹ́yìn náà",
    "settingUp": "Ó ń ṣètò...",
    "benefit1": "Kò sí ìròyìn ọ̀rọ̀-ìṣírò mọ́",
    "benefit2": "Ààbò tó pọ̀ pẹ̀lú biometric",
    "benefit3": "Wọlé pẹ̀lú ìfọwọ́ kan tàbí ìfojú",
    "biometricPrivacy": "Àkọsílẹ̀ biometric rẹ kò jáde lórí ẹ̀rọ rẹ",
    "biometricSuccess": "Ìwọlé biometric ti ṣẹ̀dá ní àṣeyọrí! 🎉",
    "biometricFailed": "Ó kùnà láti ṣètò ìwọlé biometric. O lè ṣètò lẹ́yìn náà nínú ètò.",
    "biometricSetupLater": "O lè ṣètò ìwọlé biometric lẹ́yìn náà nínú àpèjúwe rẹ"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
